import { createSlice } from "@reduxjs/toolkit";

const initialAnnouncementsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  announcementForEdit: undefined,
  lastError: null,
  pageNumber: 1,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const announcementsSlice = createSlice({
  name: "announcements",
  initialState: initialAnnouncementsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getAnnouncementById
    announcementFetched: (state, action) => {
      state.actionsLoading = false;
      state.announcementForEdit = action.payload.announcementForEdit;
      state.error = null;
    },
    // findAnnouncements
    announcementsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createAnnouncement
    announcementCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // updateAnnouncement
    announcementUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // pageNumberUpdated
    pageNumberUpdated: (state, action) => {
      const { pageNumber } = action.payload;
      state.pageNumber = pageNumber;
    },
    // deleteAnnouncement
    announcementDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // deleteAnnouncements
    announcementsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => !action.payload.ids.includes(el.id));
    },
    // announcementsUpdateState
    announcementsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
  },
});
